export enum RegistrationActionTypes {
  login='login',
  continue='continue',
}
